import { CAMPUS_ASSET_COUNTS, CAMPUS_SCALE_PROFILE } from "./profile.ts";
import { activeIncident, scenarioEvidence, serviceHealth } from "./seed.ts";

const staffWifi = serviceHealth.find((service) => service.id === "svc-staff-wifi");
const switchEvidence = scenarioEvidence.find((evidence) => evidence.id === "EVD-2048-02");

if (!staffWifi || !switchEvidence) {
  throw new Error("Guided operations fixtures require the canonical service and switch evidence anchors.");
}

export const GUIDED_OPERATION_ANCHORS = {
  incidentId: "INC-2048",
  changeId: "CHG-9012",
  switchId: "CR-SW-04",
  dataJackId: "NA-214-A1",
  endpointId: "TEL-0318",
  maintenanceTaskId: "MNT-882",
} as const;

export const GUIDED_OPERATIONS_FIXTURE = {
  narrative: {
    title: "Finals-week North Academic Center degradation",
    affectedUsers: activeIncident.affectedUsers,
    affectedServices: activeIncident.affectedServices,
    affectedBuildings: activeIncident.affectedBuildings,
  },
  baseline: {
    serviceAvailability: 99.9,
    serviceTarget: 99,
    registeredVoiceDevices: CAMPUS_ASSET_COUNTS.deskPhones,
    totalVoiceDevices: CAMPUS_ASSET_COUNTS.deskPhones,
    wifiCoveredBuildings: CAMPUS_SCALE_PROFILE.buildings,
    totalBuildings: CAMPUS_SCALE_PROFILE.buildings,
    switchState: "Healthy",
    checkedAt: "10:00",
  },
  outage: {
    serviceAvailability: staffWifi.availability,
    offlineVoiceEndpointIds: [GUIDED_OPERATION_ANCHORS.endpointId],
    affectedAreas: staffWifi.affectedBuildings,
    switchState: "Degraded",
    checkedAt: switchEvidence.observedAt,
  },
  recovery: {
    serviceAvailability: 100,
    registeredVoiceDevices: CAMPUS_ASSET_COUNTS.deskPhones,
    wifiCoveredBuildings: CAMPUS_SCALE_PROFILE.buildings,
    switchState: "Healthy",
    checkedAt: "10:43",
  },
  readiness: {
    requiredEvidenceCount: 2,
    redundancyState: "limited",
    maintenanceWindow: "outside-window",
  },
} as const;
